import axios from "axios";
import router from "../router";
import store from "../store";
import { ElMessage } from "element-plus";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

axios.interceptors.request.use(config => {
  if (store.state.app.token) {
    config.headers['Authorization'] = store.state.app.token 
  }
  return config;
}, err => {
  return Promise.reject(err)
})

axios.interceptors.response.use(
  (response) => {
    if (response?.headers?.tk && response?.headers?.tk !== store.state.app.token ) {
      store.commit("SET_TOKEN", response.headers.tk);
    }
    if (response.config.responseType == "blob") {
      return Promise.resolve(response);
    }
    if (response.data.code == "401") {
      router.push("/login");
      localStorage.clear();
    } else if (response.data.code == "200") {
      return Promise.resolve(response);
    } else if (response.data.code == "A1009" || response.data.code == "A1012") {
      ElMessage.warning({
        message: response.data.msg,
        type: "warning",
        duration: 6000,
      });
      router.push({
        path: response.data.obj.pcurl,
      });
    } else if (response.data.code == "A1014") {
      return Promise.resolve(response);
    } else if (response.data.code == "A9999") {
      ElMessage.warning({
        message: response.data.msg,
        type: "warning",
        duration: 6000,
      });
      return Promise.reject(response.data);
    } else if(response.data.code == "2999"){
      ElMessage.warning({
        message: response.data.msg,
        type: "warning",
        duration: 6000,
      });
      return Promise.resolve(response);
    } else {
      ElMessage.warning({
        message: response.data.msg,
        type: "warning",
        duration: 6000,
      });
      return Promise.reject(response.data);
    }
    return response;
  },
  (err) => {}
);
export const baseURL = URL;

export function http(url, params = {}, config = {}) {
  let headers = {
    tk: localStorage.getItem("token"),
    na: Math.random() * 100,
    ts: JSON.stringify({
      ts: new Date().getTime(),
    }),
  };
  config = {
    headers: {
      ...headers,
      ...config,
    },
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// 下载导入模板 导出文件
export function download(url, params = {}, name, type = "xlsx") {
  let formData = new FormData();
  for (let k in params) {
    formData.append(k, params[k]);
  }
  formData.append("tk", store.state.app.token);
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      responseType: "blob",
      data: formData,
      headers: {
        tk: store.state.app.token,
        na: Math.random() * 100,
      },
    })
      .then((res) => {
        const blob = new Blob([res.data]);
        const eLink = document.createElement("a");
        eLink.download = `${decodeURI(res.headers["file-name"])}`;
        eLink.style.display = "none";
        eLink.href = window.URL.createObjectURL(blob);
        document.body.appendChild(eLink);
        eLink.click();
        document.body.removeChild(eLink);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function downloads(url, params = {}, name, type = "xlsx") {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      responseType: "blob",
      data: params,
      headers: {
        tk: store.state.app.token, 
        na: Math.random() * 100,
      },
    })
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const eLink = document.createElement("a");
        eLink.download = decodeURI('学生档案.xlsx');
        eLink.style.display = "none";
        eLink.href = window.URL.createObjectURL(blob);
        document.body.appendChild(eLink);
        eLink.click();
        document.body.removeChild(eLink);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 导入文件
export function uploadFile(url, params = {}, name) {
  let formData = new FormData();
  const key = params["fileKey"] || "file";

  // 多个文件 循环传
  for (let k in params) {
    if (k == key) {
      params[k].map((item) => {
        formData.append(key, item.raw);
      });
    } else {
      formData.append(k, params[k]);
    }
  }

  formData.append("tk", store.state.token);
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      data: formData,
      headers: {
        tk: store.state.token,
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryn8D9asOnAnEU4Js0",
        na: Math.random() * 100,
      },
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
